var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex",
    attrs: {
      "id": "application-container"
    }
  }, [(_vm.loading) ? [_vm._m(0)] : [_c('div', {
    staticClass: "sidebar"
  }, [_c('v-menu')], 1), _vm._v(" "), _c('div', {
    staticClass: "content flex flex-column"
  }, [_c('v-header'), _vm._v(" "), _c('main', {
    staticClass: "flex flex-column"
  }, [_c('v-messages', {
    attrs: {
      "messages": _vm.$store.messages
    }
  }), _vm._v(" "), (_vm.showLogin) ? _c('div', {
    staticClass: "overlay"
  }, [_c('v-login', {
    on: {
      "success": _vm.handleLoginSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLogin === false),
      expression: "showLogin === false"
    }]
  })], 1), _vm._v(" "), _c('v-footer', {
    staticStyle: {
      "margin-top": "auto"
    }
  })], 1)], 1)]], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('span', {
    staticClass: "fa fa-cog fa-spin"
  }), _vm._v(" Inicializando aplicação\n\t\t")])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cc97bb7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc97bb7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/commons/layout.vue
// module id = 267
// module chunks = 3